<appTable v-if="shouldRenderConfig" :tableName="name"  v-show="alwaysShow || getShowUpload" v-bind:tableClass="getClassName">
    <appUploadContainer :alwaysShow="alwaysShow"></appUploadContainer>
</appTable>
